import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/users`, {params})
    },
    exportExcel(params) {
        return Vue.axios.get('/users', {
            params,
            responseType: 'blob',
            headers: {Accept: 'application/json'},
            timeout: 120000,
        })
    },
    create(params) {
        return Vue.axios.post(`/users/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/users/update`, params)
    },
    updateRole(params) {
        return Vue.axios.post(`/users/update-role`, params)
    },
    updateAddress(id, params) {
        return Vue.axios.post(`/users/addresses/update/${id}`, params)
    },
    remove(id) {
        return Vue.axios.get(`/users/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/users/${id}`)
    },
    giveBonuses(params) {
        return Vue.axios.post(`/users/give-bonuses`, params)
    },
    sendPromocode(params){
        return Vue.axios.post(`/users/send-promocode`, params)
    },
    chargeBonus(id, params) {
        return Vue.axios.get(`/users/${id}/charge-bonus`, {params})
    },
    getIikoData(id) {
        return Vue.axios.get(`/users/${id}/iiko-data`)
    },

    getSettings(key) {
        return Vue.axios.get(`/users/settings/${key}`)
    },
    setSettings(key, settings) {
        return Vue.axios.post(`/users/settings`, {key, settings})
    },
    listReservedBonuses(params) {
        return Vue.axios.get(`/reserved-bonuses`, {params})
    },
    removeReservedBonuses(id) {
        return Vue.axios.post(`/reserved-bonuses/${id}`, {'_method': 'delete'})
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
